const initQueueCardActions = $container => {
  if (!$container) return;

  $container.addEventListener("click", event => {
    const $button = event.target.closest(".js-assembly-queue-action");
    if (!$button) return;

    const { action, shipmentId, signalType, signalId } = $button.dataset;
    if (!shipmentId) return;

    $container.dispatchEvent(
      new CustomEvent("assembly-queue:signal-change-action", {
        detail: {
          action,
          shipmentId,
          signalType,
          signalId,
          button: $button
        }
      })
    );
  });
};

export default initQueueCardActions;
